<template>
	<div class="mgs-hole-edit-container">
		<h2 class="m-0 text-center">{{ hole.hole}}</h2>
		<button class="mgs-previous-hole button mgs-button is-small" @click="$emit('go-to-previous-hole')">< Previous</button>
		<div class="mgs-hole-edit flex items-center ml-auto">
			<div>Par</div>
			<div>
				<input
					@input="updatePar(hole)"
					ref="par"
					class="mgs-scorecard-input"
					maxlength="1"
					type="number"
					min="0"
					v-model="hole.par"
				/>
			</div>
		</div>
		<div class="mgs-hole-edit flex items-center ml-auto">
			<div>Yards</div>
			<div>
				<input
					@input="updateYards(hole)"
					ref="yards"
					class="mgs-scorecard-input"
					maxlength="3"
					type="number"
					min="0"
					v-model="hole.yards"
				/>
			</div>
		</div>
		<div class="mgs-hole-edit flex items-center ml-auto">
			<div>Stroke Index</div>
			<div>
				<input
					ref="stroke_index"
					class="mgs-scorecard-input"
					maxlength="3"
					type="number"
					min="0"
					v-model="hole.stroke_index"
				/>
			</div>
		</div>

		<button class="mgs-previous-hole button mgs-button is-small block ml-auto" @click="$emit('go-to-next-hole')">Next ></button>
	</div>
</template>
<script>
/** @format */
export default {
	name: 'CourseHoleEdit',
	props: {
		value: {
			type: Object,
			required: true
		}
	},
	watch: {
		value(h) {
			this.hole = h;
			this.$refs.par.focus();
		}
	},
	data() {
		return {
			hole: this.value
		}
	},
	methods: {
		updatePar(hole) {
			this.$emit('update-par', hole)
		},
		updateYards(hole) {
			this.$emit('update-yards', hole)
		}
	}
};
</script>
<style lang="scss">
.mgs-hole-edit-container {
	h2 {
		@apply font-bold;
	}
	background:white;
	@apply p-4;
	.mgs-previous-hole {
		@apply bg-forest-green text-white w-full my-1;
		border-radius: 6px;
	}
	.mgs-hole-edit {
		@apply text-xs my-1;
	 	div:first-child{

		}
	 	div:last-child{
			margin-left:auto;
		}
		select {
			width:60px;
			margin-left:auto;
		}
		.mgs-scorecard-input {
			border-bottom: 1px solid;
		}
	}
}
</style>
